var Pikaday = require('pikaday');
require('pikaday/css/pikaday.css');
var moment = require('moment');

function initSerial() {
	if( $('#serial').length ) {
		var picker = new Pikaday({
			field: $('#bought-date')[0],
			firstDay : 1,
			i18n: {
			    previousMonth : 'Mois suivant',
			    nextMonth     : 'Mois précédent',
			    months        : ['Janvier','Février','Mars','Avril','Mai','Juin', 'Juillet','Août','Septembre','Octobre','Novembre','Decembre'],
			    weekdays      : ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
			    weekdaysShort : ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
			},
			format: "DD/MM/YYYY",
		})

		var ean13 = $('#ean13').val();

		if(ean13) {
			changeEan13(ean13);
		}

		$('#serial_form').on('submit', function(e) {
			e.preventDefault();
			e.returnValue = false;

			validateSerialForm();
		});

		$('button[name=submitEan13]').on('click', function(e) {
			e.preventDefault();

			changeEan13($('#ean13').val());
		});

		$('#serial_confirm').bind('paste', function(e) {
			e.preventDefault();
		});

		$('#submitAccount').on('click', function(e){
			$('#cgu').parent().find('.error').hide();
			if( !$('#cgu').is(':checked') ){
				$('#cgu').parent().find('.error').show();
				return false;
			}

		});

		if( $('#serial_errors ol').length )
			$("html, body").animate({ scrollTop: $('#serial_errors').offset().top });
	}
}

function validateSerialForm() {
	$.ajax({
		type: 'POST',
		url: baseUri + '?rand=' + new Date().getTime(),
		async: true,
		cache: false,
		dataType : "json",
		headers: { "cache-control": "no-cache" },
		data:
		{
			controller: 'serial',
			submitSerial: 1,
			ajax: true,
			token: token,
			ean13: $('input[name=ean13]').val(),
			serial: $('input[name=serial]').val(),
			serial_confirm: $('input[name=serial_confirm]').val(),
			id_store: $('input[name=id_store]').val(),
			bought_date: $('input[name=bought_date]').val(),
			store_purchase: $('input[name=store_purchase]').val(),
		},

		success: function(jsonData)
		{
			if (jsonData.hasError && jsonData.errors.length > 0)
			{
				var html = "";
				html += '<div class="row">';
				html += '<div class="alert alert-danger">';
				html += '<ol>';

				$.each(jsonData["errors"], function(index, value)
				{
					html += '<li>'+value+'</li>';
				});

				html += '<ol>';
				html += '</div>';
				html += '</div>';

				$('#serial_errors').html(html);
				$('#serial_errors').show();

				$('html, body').animate({
				  scrollTop: $('#serial_errors').offset().top
				}, 1000);

				return false;
			}
			else
			{
				$('#serial_errors').html("");
				$('#serial_errors').hide();

				$('#serial_form').off('submit');
				$('#serial_form').submit();
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown)
		{
			console.log("TECHNICAL ERROR: unable to load form.\n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
		}
	});

	return false;
}

function changeEan13(ean13) {
	$.ajax({
		type: 'POST',
		url: baseUri + '?rand=' + new Date().getTime(),
		async: true,
		cache: false,
		dataType : "json",
		headers: { "cache-control": "no-cache" },
		data:
		{
			controller: 'serial',
			submitChangeEan13: 1,
			ajax: true,
			token: token,
			ean13: ean13,
		},

		success: function(jsonData)
		{
			if (jsonData.hasError && jsonData.errors.length > 0)
			{
				$.each(jsonData["errors"], function(index, value)
				{
					console.log(value);
				});
			}
			else
			{
				var html = "";

				if(jsonData["products"].length > 0) {
					// On ne sélectionne que le premier produit. Si il y en a plusieurs c'est une erreur de saisie dans le BO
					var product = jsonData["products"][0];

					html += '<div class="ean13-product-content">';
					html += '<img src="'+product.image_link+'" alt="'+product.name+'" />';
					html += '<span class="product_item_name">'+product.name+'</span>';
					html += '</div>';

					// Affichage des données
					$('#ean13_product').html(html);
					$('.step-2').removeClass('hidden-form');

					// Masquage des données
					$('.serial-errors, .submit-ean13').addClass('hidden-form');
				}
				else {
					$('.ean13 .alert-danger').html('Le code EAN est inconnu');
				}
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown)
		{
			console.log("TECHNICAL ERROR: unable to load form.\n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
		}
	});
}

module.exports = initSerial;


// WEBPACK FOOTER //
// ./js/serial.js